import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 mt-16">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">The Central Coast Times</h3>
            <p className="text-sm leading-relaxed">
              Providing balanced perspectives and the other side of the story. We believe every story deserves to be told from all angles.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/submit-story" className="hover:text-white transition-colors">Submit Your Story</Link></li>
              <li><Link to="/newsletter" className="hover:text-white transition-colors">Newsletter</Link></li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Categories</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/category/local-news" className="hover:text-white transition-colors">Local News</Link></li>
              <li><Link to="/category/sports" className="hover:text-white transition-colors">Sports</Link></li>
              <li><Link to="/category/entertainment" className="hover:text-white transition-colors">Entertainment</Link></li>
              <li><Link to="/category/lifestyle" className="hover:text-white transition-colors">Lifestyle</Link></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Stay Updated</h3>
            <p className="text-sm mb-4">Subscribe to our newsletter for balanced news coverage.</p>
            <Link
              to="/newsletter"
              className="inline-block px-4 py-2 bg-white text-gray-900 rounded-lg hover:bg-gray-100 transition-colors text-sm font-medium"
            >
              Subscribe Now
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-400">
            © 2025 The Central Coast Times. All rights reserved.
          </p>
          <div className="flex gap-4 mt-4 md:mt-0">
            <a href="https://www.facebook.com/share/1C85TV86WH/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" aria-label="Facebook">
              <Facebook size={20} />
            </a>
            <a href="https://www.instagram.com/centralcoast_times" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" aria-label="Instagram">
              <Instagram size={20} />
            </a>
            <a href="mailto:hello@centralcoasttimes.com" className="hover:text-white transition-colors" aria-label="Email">
              <Mail size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;